module.exports = __webpack_public_path__ + "static/img/logo_bancos.ab06840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payments/logo_bancos.png
// module id = 204
// module chunks = 1